import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { BffApiService } from '@shared/bff-api.service';

@Component({
  selector: 'app-page-reset-pasword',
  templateUrl: './page-reset-pasword.component.html',
  styleUrls: ['./page-reset-pasword.component.scss'],
  imports: [ReactiveFormsModule],
})
export class PageResetPaswordComponent {
  reset_pwd_form: FormGroup = this.fb.group({
    email: [null, Validators.required],
  });

  constructor(private fb: FormBuilder, private bff: BffApiService) {}

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.reset_pwd_form = this.fb.group({
      email: [null, Validators.required],
    });
  }

  submit() {
    this.bff.login(this.reset_pwd_form.value).subscribe((data) => console.log(data));
    console.log(this.reset_pwd_form.value);
  }
}
